/**
 * 관리자·판매관리센터 자동 zoom 은 쓰지 않는다.
 * (와이드 모니터에서 새로고침 시 화면만 커지고 가로 스크롤이 생기는 문제가 있어 제거)
 */
export function useManageUiScale() {
  return { scaleStyle: {} }
}
